import styled from 'styled-components';

export const GstinContainer = styled.div`
  max-height: 240px;
  height: auto;
  margin: 0 0 2rem 0;
  display: none;
`